import { render } from "./parelchart.vue?vue&type=template&id=dd504bfe&scoped=true"
import script from "./parelchart.vue?vue&type=script&lang=js"
export * from "./parelchart.vue?vue&type=script&lang=js"

import "./parelchart.vue?vue&type=style&index=0&id=dd504bfe&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd504bfe"]])

export default __exports__